import LeaseInvoice from './LeaseInvoice';
import LeaseLessor from './LeaseLessor';
import LeaseMaster from './LeaseMaster';
import RecordingDetail from './RecordingDetail';

// tslint:disable: variable-name
export default class LeaseRecording {
    // lr_tg is the primary key in this case.
    lr_tg: number;
    li_tg: number;
    rec_date?: Date;
    book?: string;
    page?: string;
    use_book?: string;
    assign_no?: number;
    assign_date?: Date;
    tran_date?: Date;
    transmit_no?: number;
    county?: string;
    state?: string;
    rec_fee?: number;
    check_no?: number;
    mod_by?: string;
    mod_dt?: Date;
    assign_order?: number;
    recording_status?: number;

    // not mapped
    working_interest?: number;

    lease_invoice?: LeaseInvoice;
    lease_lessor?: LeaseLessor;
    recording_detail?: RecordingDetail;
    lease_master?: LeaseMaster;

    static forTest = (id: number): LeaseRecording => {
        let test: LeaseRecording = {
            lr_tg: id,
            li_tg: 378520,
            rec_date: new Date('2024-11-20'),
            book: '2024R007294',
            page: '5',
            use_book: 'Y',
            county: 'Miller',
            state: 'AR',
            rec_fee: 29,
            check_no: 2024112201,
            mod_by: 'Chris T. Foster',
            mod_dt: new Date('2024-11-20'),
            recording_status: 2,
            working_interest: 0.45,
            lease_invoice: LeaseInvoice.forTest(378520, 203996),
            lease_lessor: LeaseLessor.forTest(203996)
        };

        return test;
    };
}


// WEBPACK FOOTER //
// ./src/models/dlcLease/LeaseRecording.ts